/**
 * ReadingProgress 스타일
 * @description 창 위쪽 가장자리에 붙는 가는 띠. 브랜드에서 하이라이트 보라로 흐르는 그라데이션 —
 *   두 색 다 토큰이다. 채움은 `transform: scaleX` 로 그린다(폭을 바꾸면 매 프레임 레이아웃이
 *   돈다). 초기값은 인라인 스타일이 준다 — Tailwind 의 `scale-x-*` 는 `scale` 속성이라
 *   스크립트가 쓰는 `transform` 과 따로 논다.
 */
export const readingProgressStyles = {
  /* 창 폭 전체 — 헤더(z-30) 위에 선다. 헤더 안에 두면 backdrop-filter 가 fixed 의 기준이 돼 열 폭에 갇힌다 */
  track:
    "pointer-events-none fixed inset-x-0 top-0 z-40 h-[3px] overflow-hidden",
  fill: "h-full w-full origin-left rounded-r-[var(--fw-radius-full)] bg-linear-to-r from-(--fw-color-content-brand-primary) to-(--fw-color-surface-highlight-primary) transition-transform duration-150 ease-out motion-reduce:transition-none",
};
